import PropTypes from 'prop-types';
import { Box } from '@qga/roo-ui/components';
import Occupants from 'components/Occupants';
import { ColumnItem, H2Title, ItemContent, ItemLabel } from '../primitives';
import { Column, Row } from '../../primitives';

const BookingDetails = ({ leadGuestName, totalAdults, totalChildren, totalInfants, checkIn, checkInAfter, checkOut, checkOutBefore }) => (
  <Box as="article">
    <H2Title>Your booking details</H2Title>
    <Row>
      <Column width={['33.33%', 'auto']}>
        <ColumnItem>
          <ItemLabel>Guests</ItemLabel>
          <ItemContent>Reserved for {leadGuestName}</ItemContent>
          <ItemContent fontSize="xs" lineHeight="16px">
            <Occupants numberOfAdults={totalAdults} numberOfChildren={totalChildren} numberOfInfants={totalInfants} />
          </ItemContent>
        </ColumnItem>
      </Column>
      <Column width={['33.33%', 'auto']}>
        <ColumnItem>
          <ItemLabel>Check-in date</ItemLabel>
          <ItemContent>{checkIn}</ItemContent>
          <ItemContent fontSize="xs" lineHeight="16px">
            From {checkInAfter}
          </ItemContent>
        </ColumnItem>
      </Column>
      <Column width={['33.33%', 'auto']}>
        <ColumnItem>
          <ItemLabel>Check-out date</ItemLabel>
          <ItemContent>{checkOut}</ItemContent>
          <ItemContent fontSize="xs" lineHeight="16px">
            Until {checkOutBefore}
          </ItemContent>
        </ColumnItem>
      </Column>
    </Row>
  </Box>
);

BookingDetails.propTypes = {
  leadGuestName: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  totalAdults: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  totalChildren: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  totalInfants: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  checkIn: PropTypes.string.isRequired,
  checkInAfter: PropTypes.string.isRequired,
  checkOut: PropTypes.string.isRequired,
  checkOutBefore: PropTypes.string.isRequired,
};

export default BookingDetails;
